import api from "./api";

export default {
  getAll: (params = {}) => api.get("/produtos", { params }),
  getById: (id) => api.get(`/produtos/${id}`),
  create: (data) => api.post("/produtos", { produto: data }),
  update: (id, data) => api.put(`/produtos/${id}`, { produto: data }),
  destroy: (id) => api.delete(`/produtos/${id}`),
  toggleAtivo: (id) => api.patch(`/produtos/${id}/toggle_ativo`),
  produzir: (id, data) => api.post(`/produtos/${id}/produzir`, data),
  ajustarEstoque: (id, data) =>
    api.post(`/produtos/${id}/ajustar_estoque`, data),
  movimentos: (id) => api.get(`/produtos/${id}/movimentos`),
  alertasEstoque: () => api.get(`/produtos/alertas_estoque`),
  diagnosticoReservas: () => api.get(`/produtos/diagnostico_reservas`),
};
